import {InjectionToken} from '@angular/core';

export interface AppConfig {
  baseUrl: string;
  imgBase: string;
}

export const APP_CONFIG = new InjectionToken<AppConfig>('app.config');


export const SESSION_KEY = 'coffee_session';
export const CART_KEY = 'coffee_cart';


export interface StorageConfig {
  session: string;
  user: string;
  favorites: string;
}

export const STORAGE_CONFIG = new InjectionToken<StorageConfig>('storage.config');
